import { FC } from 'react'
import { IconClass } from '../../../_metronic/helpers'
import styles from './IconChip.module.css'

type IconChipProps = {
  icon: IconClass
  className?: string
}

export const IconChip: FC<IconChipProps> = ({ icon, className = '' }) => (
  <span className={`${styles.chip} ${className}`}>
    <i className={`bi ${icon}`} />
  </span>
)
